// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/list_credit_packs.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { CreditPack } from "./vision_billing_pb";
import { file_vision_billing_v1_vision_billing } from "./vision_billing_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/list_credit_packs.proto.
 */
export const file_vision_billing_v1_list_credit_packs: GenFile = /*@__PURE__*/
  fileDesc("Cil2aXNpb24vYmlsbGluZy92MS9saXN0X2NyZWRpdF9wYWNrcy5wcm90bxIYcHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxImsKFkxpc3RDcmVkaXRQYWNrc1JlcXVlc3QSRwoGcGFyYW1zGAEgASgLMjcucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RDcmVkaXRQYWNrc1JlcXVlc3QuUGFyYW1zGggKBlBhcmFtcyKiAQoXTGlzdENyZWRpdFBhY2tzUmVzcG9uc2USSAoGcmVzdWx0GAEgASgLMjgucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkxpc3RDcmVkaXRQYWNrc1Jlc3BvbnNlLlJlc3VsdBo9CgZSZXN1bHQSMwoFcGFja3MYASADKAsyJC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ3JlZGl0UGFja2IGcHJvdG8z", [file_vision_billing_v1_vision_billing]);

/**
 * @generated from message protos.vision.billing.v1.ListCreditPacksRequest
 */
export type ListCreditPacksRequest = Message<"protos.vision.billing.v1.ListCreditPacksRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ListCreditPacksRequest.Params params = 1;
   */
  params?: ListCreditPacksRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditPacksRequest.
 * Use `create(ListCreditPacksRequestSchema)` to create a new message.
 */
export const ListCreditPacksRequestSchema: GenMessage<ListCreditPacksRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_packs, 0);

/**
 * @generated from message protos.vision.billing.v1.ListCreditPacksRequest.Params
 */
export type ListCreditPacksRequest_Params = Message<"protos.vision.billing.v1.ListCreditPacksRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditPacksRequest.Params.
 * Use `create(ListCreditPacksRequest_ParamsSchema)` to create a new message.
 */
export const ListCreditPacksRequest_ParamsSchema: GenMessage<ListCreditPacksRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_packs, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.ListCreditPacksResponse
 */
export type ListCreditPacksResponse = Message<"protos.vision.billing.v1.ListCreditPacksResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.ListCreditPacksResponse.Result result = 1;
   */
  result?: ListCreditPacksResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditPacksResponse.
 * Use `create(ListCreditPacksResponseSchema)` to create a new message.
 */
export const ListCreditPacksResponseSchema: GenMessage<ListCreditPacksResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_packs, 1);

/**
 * @generated from message protos.vision.billing.v1.ListCreditPacksResponse.Result
 */
export type ListCreditPacksResponse_Result = Message<"protos.vision.billing.v1.ListCreditPacksResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.billing.v1.CreditPack packs = 1;
   */
  packs: CreditPack[];
};

/**
 * Describes the message protos.vision.billing.v1.ListCreditPacksResponse.Result.
 * Use `create(ListCreditPacksResponse_ResultSchema)` to create a new message.
 */
export const ListCreditPacksResponse_ResultSchema: GenMessage<ListCreditPacksResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_list_credit_packs, 1, 0);

